import dayjs from "dayjs";
import { DateInput } from "semantic-ui-calendar-react";
import { Button, Input } from "semantic-ui-react";
import { getPayments } from "services/payment";

export default function FilterBar(props: any): JSX.Element {
  const { loading, setLoading } = props;
  const {
    queryString,
    setQueryString,
    searchByQueryString,
    setPayments,
    selectedRecords,
    popup,
    setPopup,
    setSelectedRecords,
  } = props;

  return (
    <div className="flex flex-col flex-wrap gap-2 py-1 px-2 text-left md:justify-between md:flex-row">
      <div></div>
      <div className="flex gap-2">
        <div>
          <Input
            name="any"
            placeholder="Search by any"
            value={queryString.any}
            onChange={(e, data) => {
              const { name, value } = data || e;
              setQueryString({ ...queryString, [name]: value });
            }}
          />
        </div>
        {/* <div>
          <DateInput
            // label="Filter by Check-in Date: "
            name="checkInDate"
            placeholder="Filter by Check-in Date"
            // value={dayjs().format('YYYY-MM-DD')}
            dateFormat="YYYY-MM-DD"
            iconPosition="right"
            closable
            clearable
            startMode="day"
            popupPosition="bottom center"
            value={queryString.checkInDate || ""}
            onChange={(e, data) => {
              const { name, value } = data || e;
              // console.log(dayjs(data.value).format('YYYY-MM-DD'))
              setQueryString({
                ...queryString,
                [name]: dayjs(value).isValid()
                  ? dayjs(value).format("YYYY-MM-DD")
                  : "",
              });
            }}
          />
        </div> */}
        <div>
          <DateInput
            // label="Filter by Check-in Date: "
            name="createdAt"
            placeholder="Filter by Payment Date"
            // value={dayjs().format('YYYY-MM-DD')}
            dateFormat="YYYY-MM-DD"
            iconPosition="right"
            closable
            clearable
            startMode="day"
            popupPosition="bottom center"
            value={queryString.createdAt || ""}
            onChange={(e, data) => {
              const { name, value } = data || e;
              // console.log(dayjs(data.value).format('YYYY-MM-DD'))
              setQueryString({
                ...queryString,
                [name]: dayjs(value).isValid()
                  ? dayjs(value).format("YYYY-MM-DD")
                  : "",
              });
            }}
          />
        </div>
      </div>
      {/*
       */}
      <div>
        <Button
          content={
            selectedRecords.length === 0
              ? `Settlement`
              : `Settlement (${selectedRecords.length})`
          }
          // icon="refresh"
          color="green"
          loading={loading}
          disabled={selectedRecords.length === 0}
          onClick={async () => {
            setPopup({ ...popup, settlement: true });
          }}
        />
        <Button
          content="Update list"
          icon="refresh"
          color="yellow"
          loading={loading}
          disabled={loading}
          onClick={async () => {
            setLoading(true);
            setPayments([...(await getPayments(queryString))]);
            setLoading(false);
          }}
        />
      </div>
    </div>
  );
}
